var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevelMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M30 1C6.8 1 1 4.86667 1 6.8V31.9333C4.54444 37.7333 15.3067 49.3333 30 49.3333C44.6933 49.3333 55.4556 37.7333 59 31.9333V6.8C59 4.86667 53.2 1 30 1Z",
    stroke: "#FFD700",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelMax);
export default __webpack_public_path__ + "static/media/level-max.8469317cb0063136b01c2f308c0ba909.svg";
export { ForwardRef as ReactComponent };